import React from "react";
import styled from "@emotion/styled";
import { Checkbox } from "antd";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { CustomSelect as Select, FieldContainer, Option } from ".";

const CheckboxWithImageAndQuantity = ({
  name,
  label,
  desc,
  image,
  options,
  isSelected,
  selectedValues,
  setSelectedValues,
  groupName,
  defaultValue,
}) => (
  <Container isSelected={isSelected}>
    <Top
      onClick={(e) => {
        const value = !isSelected;
        if (value) {
          if (!selectedValues) {
            selectedValues = [name];
          } else if (!selectedValues.includes(name)) {
            selectedValues = [...selectedValues, name];
          }
          setSelectedValues({
            [name]: defaultValue,
            [groupName]: selectedValues,
          });
        } else {
          const index = selectedValues.indexOf(name);
          if (index > -1) {
            selectedValues.splice(index, 1);
          }
          setSelectedValues({
            [name]: undefined,
            [groupName]: selectedValues,
          });
        }
      }}
    >
      <CheckboxItem
        value={name}
        disabled={true}
        onChange={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
      <Title isSelected={isSelected}>{label}</Title>
      <Description>{desc}</Description>
      <Image src={image} />
    </Top>
    <Footer isSelected={isSelected}>
      <FooterLabel>จำนวน</FooterLabel>
      <FieldContainer name={name}>
        <CustomSelect placeholder="ระบุ" disabled={!isSelected}>
          {options.map((opt) => (
            <Option value={opt.value}>{opt.label}</Option>
          ))}
        </CustomSelect>
      </FieldContainer>
    </Footer>
  </Container>
);

const Container = styled.div`
  width: 254px;
  display: flex;
  flex-direction: column;
  align-items: center;

  border: 1px solid ${(props) => (props.isSelected ? "#16af7b" : "#E7EAEE")};
  border-radius: 8px;
  margin: 0 2px;

  margin-top: 16px;
  margin-bottom: 32px;
  overflow: hidden;
  padding-top: 5px;

  ${responsive.mobile(css`
    width: 112px;
    margin-bottom: 16px;
  `)}
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

const CustomSelect = styled(Select)`
  height: 42px;
  width: calc(100% - 20px) !important;

  margin: 0 10px 8px;

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
  }

  ${responsive.mobile(css`
    width: calc(100% - 12px) !important;

    margin: 0 6px 8px;
  `)}
`;

export const CheckboxItem = styled(Checkbox)`
  font-weight: 700 !important;
  margin-bottom: 24px;

  --antd-wave-shadow-color: #058459;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #058459 !important;
    border-color: #058459 !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #058459 !important;
  }

  &.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled,
  .ant-checkbox-disabled {
    cursor: pointer !important;
  }

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #f5f5f5 !important;
  }

  ${responsive.mobile(css`
    margin-bottom: 16px;
  `)}
`;

const Title = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;

  color: ${(props) => (props.isSelected ? "#047751" : "#4b5768")};

  margin-top: 14px;
`;

const Description = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  text-align: center;

  color: #4b5768;
  margin-top: 2px;

  ${responsive.mobile(css`
    font-size: 13px;
  `)}
`;

const Image = styled.img`
  width: 238px;
  height: 306px;

  margin-top: 10px;

  ${responsive.mobile(css`
    width: 90px;
    height: auto;
  `)}
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 10px;

  background-color: ${(props) => (props.isSelected ? "#16AF7B" : "#B8C0CC")};
`;

const FooterLabel = styled.div`
    font-family: 'Noto Sans Thai';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;

    color: #FFFFFF;

    margin-top; 4px;
`;

export default CheckboxWithImageAndQuantity;
